export default __webpack_public_path__ + "static/media/link_1.301176a1.png";